export default "__VITE_ASSET__l$G2Wc$6__"